/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_No_Display_Settings_MessageInputs */



/**
* | output |
* | --- |
* | "No valid display settings provided to update" |
*
* @param {Iframe_Remote_No_Display_Settings_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_no_display_settings_message = /** @type {((inputs?: Iframe_Remote_No_Display_Settings_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_No_Display_Settings_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun parametre d'affichage valide a mettre a jour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurden keine gültigen Anzeigeeinstellungen für ein Update angegeben.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna impostazione di visualizzazione valida fornita per l'aggiornamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не предоставлены допустимые параметры отображения для обновления.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se proporcionaron configuraciones de pantalla válidas para actualizar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未提供有效的显示设置以进行更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("更新するための有効な表示設定が指定されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपडेट करने के लिए कोई वैध डिस्प्ले सेटिंग प्रदान नहीं की गई है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma configuração de exibição válida foi fornecida para atualização.")
	return /** @type {LocalizedString} */ ("No valid display settings provided to update")
});